import {useEffect, useState} from "react";
import {FormTextField} from "./FormTextField";
import * as React from "react";
import {normalizeDecimalString} from "../utils/NumberUtils";

function DecimalFormField(props) {
  const {value, disabled, size, name, label, minVal, maxVal, onChange, onBlur, id, sx, variant} = props
  const [valueStr, setValueStr] = useState(`${value}`)

  useEffect(() => {
    setValueStr(`${value}`)
  }, [value])

  // state variable as object: concept to keep in mind
  // const [values, setValues] = useState({
  //   num: 1,
  //   str: '1'
  // });

  function onBlurLocal(evt) {
    let rawValue = normalizeDecimalString(evt.target.value)
    if (rawValue.endsWith('.')) {
      rawValue = rawValue.substring(0, rawValue.length - 1)
    }
    if (rawValue === '') {
      rawValue = '0'
    }
    setValueStr(rawValue)

    let floatValue = parseFloat(rawValue)
    if (maxVal !== undefined && floatValue > maxVal) {
      floatValue = maxVal
    } else if (minVal !== undefined && floatValue < minVal) {
      floatValue = minVal
    }

    onChange(evt.target.name, floatValue, id)

    if (onBlur !== undefined) {
      onBlur(evt)
    }
  }

  function onDecimalFieldChange(evt) {
    const rawValue = normalizeDecimalString(evt.target.value)
    if (rawValue === undefined) {
      return
    }
    setValueStr(rawValue)
    const floatValue = parseFloat(rawValue)
    onChange(evt.target.name, floatValue, id)
  }


  return (
    <FormTextField size={size}
                   sx={sx}
                   id="outlined-required"
                   disabled={disabled}
                   name={name}
                   label={label}
                   value={valueStr}
                   onChange={onDecimalFieldChange}
                   onBlur={onBlurLocal}
                   variant={variant ? variant : 'filled'}/>
  )
}

export {DecimalFormField}